import {button,escapeHtml,panel} from '../ui/components.js';

function plural(value,one,few,many){
  const n=Math.abs(Number(value)||0);
  if(n===1)return one;
  const mod10=n%10,mod100=n%100;
  if(mod10>=2&&mod10<=4&&!(mod100>=12&&mod100<=14))return few;
  return many;
}

function countCopy(count,forms){
  return `${count} ${plural(count,...forms)}`;
}

function itemAction({label,attribute,id}={}){
  if(!attribute||!id)return '';
  return `<button type="button" class="button button-ghost smokehouse-item-action" ${escapeHtml(attribute)}="${escapeHtml(id)}">${escapeHtml(label||'Edytuj')}</button>`;
}

function listMarkup(items,{emptyText,itemLabel,actionLabel='Edytuj',actionAttribute=null}={}){
  if(!items?.length)return `<p class="smokehouse-empty">${escapeHtml(emptyText||'Brak danych')}</p>`;
  return `<ul class="smokehouse-list">${items.slice(0,4).map(item=>
    `<li><span>${escapeHtml(itemLabel(item))}</span>${itemAction({label:actionLabel,attribute:actionAttribute,id:item.id})}</li>`
  ).join('')}</ul>`;
}

function profilePanel(model){
  const level=model.profile.experienceLevel;
  const copy=level
    ?`Poziom doświadczenia: ${level}`
    :'Uzupełnij poziom doświadczenia i preferencje.';
  return panel({
    title:'Twój profil wędzenia',
    subtitle:copy,
    body:`<div class="actions">${button({id:'smokehouse-edit-profile',label:level?'Edytuj profil':'Uzupełnij profil',variant:'secondary'})}</div>`,
    className:'smokehouse-card'
  });
}

function smokersPanel(model){
  const items=model.smokers.items||[];
  const body=`
    <p class="smokehouse-card-count">${escapeHtml(countCopy(model.smokers.count,['wędzarnia','wędzarnie','wędzarni']))}</p>
    ${listMarkup(items,{
      emptyText:'Nie masz jeszcze dodanej wędzarni.',
      itemLabel:item=>item.isDefault?`${item.name} · domyślna`:item.name,
      actionAttribute:'data-smokehouse-edit-smoker'
    })}
    <div class="actions">${button({id:'smokehouse-add-smoker',label:'Dodaj wędzarnię'})}${model.smokers.empty?'':button({id:'smokehouse-manage-smokers',label:'Zarządzaj',variant:'secondary'})}</div>`;
  return panel({title:'Wędzarnie',body,className:'smokehouse-card'});
}

function thermometersPanel(model){
  const items=model.thermometers.items||[];
  const body=`
    <p class="smokehouse-card-count">${escapeHtml(countCopy(model.thermometers.count,['termometr','termometry','termometrów']))}</p>
    ${listMarkup(items,{
      emptyText:'Dodaj termometr, jeśli chcesz zapisywać swój sprzęt pomiarowy.',
      itemLabel:item=>item.channelCount?`${item.name} · ${item.channelCount} kanały`:item.name,
      actionAttribute:'data-smokehouse-edit-thermometer'
    })}
    <div class="actions">${button({id:'smokehouse-add-thermometer',label:'Dodaj termometr',variant:'secondary'})}${model.thermometers.empty?'':button({id:'smokehouse-manage-thermometers',label:'Zarządzaj',variant:'ghost'})}</div>`;
  return panel({title:'Termometry',body,className:'smokehouse-card'});
}

function woodPanel(model){
  const items=model.wood.items||[];
  const body=`
    <p class="smokehouse-card-count">${escapeHtml(countCopy(model.wood.availableCount,['rodzaj drewna','rodzaje drewna','rodzajów drewna']))}</p>
    ${listMarkup(items,{
      emptyText:'Dodaj drewno, które masz obecnie dostępne.',
      itemLabel:item=>item.quantity!=null&&item.quantityUnit
        ?`${item.label} · ${item.quantity} ${item.quantityUnit}`
        :item.label,
      actionAttribute:'data-smokehouse-edit-wood'
    })}
    <div class="actions">${button({id:'smokehouse-add-wood',label:'Dodaj drewno',variant:'secondary'})}${model.wood.empty?'':button({id:'smokehouse-manage-wood',label:'Zarządzaj',variant:'ghost'})}</div>`;
  return panel({title:'Drewno',body,className:'smokehouse-card'});
}

function primaryAction(model){
  const map={
    resume_onboarding:{id:'smokehouse-resume-onboarding',label:'Kontynuuj konfigurację'},
    add_smoker:{id:'smokehouse-add-smoker-primary',label:'Dodaj pierwszą wędzarnię'},
    choose_default_smoker:{id:'smokehouse-choose-default',label:'Wybierz domyślną wędzarnię'},
    open_default_smoker:{id:'smokehouse-open-default',label:'Otwórz domyślną wędzarnię'}
  };
  return map[model.primaryAction]||map.add_smoker;
}

export function smokehouseDashboardMarkup(model){
  if(!model||typeof model!=='object')throw new TypeError('Smokehouse dashboard model is required');
  const action=primaryAction(model);
  const onboarding=model.onboarding?.needsAttention
    ?`<div class="message message-warning" role="status">Konfiguracja „Mojej wędzarni” nie jest jeszcze zakończona.</div>`
    :'';

  return `<section class="smokehouse-dashboard" aria-labelledby="smokehouse-dashboard-title">
    <div class="smokehouse-dashboard-header">
      <div>
        <span class="eyebrow">Moja wędzarnia</span>
        <h2 id="smokehouse-dashboard-title">Twój sprzęt i preferencje</h2>
        <p>To tutaj Dymistrz przechowuje kontekst potrzebny do receptur, planowania i późniejszych podpowiedzi.</p>
      </div>
      ${button({id:action.id,label:action.label})}
    </div>
    ${onboarding}
    <div class="smokehouse-summary-grid">
      ${smokersPanel(model)}
      ${thermometersPanel(model)}
      ${woodPanel(model)}
      ${profilePanel(model)}
    </div>
  </section>`;
}
